<gp-report-definition *ngIf="cliRegId"
                      [cliRegIds]="[cliRegId]"
                      [types]="reportTypesToFetch"
                      [hiddenValues]="hiddenValuesForReportDefinition"
                      [selectedReportDefinition]="selectedReport"
                      (reportDefinitionsLoaded)="reportsLoaded($event)"
                      (reportDefinitionListener)="reportListener($event)"
                      [profileMode]="profileMode">
</gp-report-definition>

<gp-report-list
  [reports]="reports"
  (selectedReport)="onReportSelection($event)">
</gp-report-list>

